import { takeLatest, put, call, select } from 'redux-saga/effects';
import { UPLOAD_FILE_SAGA } from "../sagaTypes";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { loaderAction, uploadFileAction } from "../rootReducer";
import { updateEstablishmentSagaAction } from "../sagaActions";
import { url } from "../../config";
import growl from "../../lib/growl/growl";

const request = data => {
    return fetch(`${ url }/upload_file`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerUploadFile(args) {
    const user = yield select(state => state.user);
    const upload_file = yield select(state => state.upload_file);
    const docs = yield select(state => state.docs);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('file', args.data.file);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Добавление нового файла
            if (args.data.id === 'add') {
                yield put(uploadFileAction({ ...upload_file, link: response.link }));
            }
            else if (Number.isInteger(args.data.id)) {
                let newDocs = [...docs];
                newDocs[args.data.id] = { ...newDocs[args.data.id], link: response.link };

                yield put(updateEstablishmentSagaAction({
                    field: 'docs',
                    value: JSON.stringify(newDocs)
                }));
            }
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherUploadFile() {
    yield takeLatest(UPLOAD_FILE_SAGA, workerUploadFile);
}